import {PropsWithChildren} from 'react';
import {
    Edit,
    Delete,
    DoorToggle,
    MoveDown,
    MoveUp,
    RotateRight,
    Copy,
    Movement,
    PlaceholderEdit,
    PlaceholderDuplicate,
    PlaceholderDelete,
} from 'components/customer/RoomPlanner/components/FloatingMenu/Actions';

const FloatingMenuOption = ({children}: PropsWithChildren) => children;

FloatingMenuOption.Edit = Edit;
FloatingMenuOption.Copy = Copy;
FloatingMenuOption.DoorToggle = DoorToggle;
FloatingMenuOption.RotateRight = RotateRight;
FloatingMenuOption.Delete = Delete;
// TODO: Temporarily disabled - may be re-enabled in the future
FloatingMenuOption.MoveUp = MoveUp;
FloatingMenuOption.MoveDown = MoveDown;
FloatingMenuOption.Movement = Movement;
FloatingMenuOption.PlaceholderEdit = PlaceholderEdit;
FloatingMenuOption.PlaceholderDuplicate = PlaceholderDuplicate;
FloatingMenuOption.PlaceholderDelete = PlaceholderDelete;

export default FloatingMenuOption;
